import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import classNames from 'classnames/bind';
import { MediaGallery, Image, Loader } from 'shared';
import Box from 'shared_DEPRECATED/components/Box/Box';
import Button from 'shared_DEPRECATED/components/Button/Button';
import { Attachments } from 'shared_DEPRECATED/types/Attachment';

import ChatMessageImageModal from 'features/chat/components/ChatMessages/ChatMessageImageModal';
import { getMediaAttachmentStyles } from 'features/chat/utils';

import { SIZES, modal } from 'shared/components/Modal';

import styles from 'features/chat/components/Chat.module.css';

type ChatMessageImageAttachmentProps = {
  name: string;
  url: string;
  attachmentKey?: string;
  isLastAttachment: boolean;
  index: number;
  media: Attachments;
  contentType: string;
};

const cx = classNames.bind(styles);

const ChatMessageImageAttachment = ({
  name,
  url,
  attachmentKey,
  isLastAttachment,
  index,
  media,
  contentType,
}: ChatMessageImageAttachmentProps) => {
  const methods = useFormContext();
  const { borderRadius, flexBasis, aspectRatio } = getMediaAttachmentStyles(
    index,
    isLastAttachment
  );

  const handleImageClick = useCallback(
    (media: Attachments, name: string, contentType: string) => {
      return modal.open({
        content:
          media.length > 1 ? (
            <MediaGallery media={media as any[]} selectedMediaIndex={index} />
          ) : (
            <ChatMessageImageModal
              url={media[0].url}
              name={name}
              contentType={contentType}
            />
          ),
        props: {
          title: '',
          size: SIZES.SM,
        },
        context: {
          chatFormMethods: methods,
        },
      });
    },
    [methods, index]
  );

  return (
    <Box
      style={{
        flexBasis,
        aspectRatio,
        position: 'relative',
      }}
    >
      {!attachmentKey && (
        <Box
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.1)',
            backdropFilter: 'blur(10px)',
            borderRadius,
          }}
        >
          <Loader color="var(--white)" />
        </Box>
      )}
      <Button
        className={cx('chat__image-btn')}
        onClick={() => handleImageClick(media, name, contentType)}
      >
        <Image
          height="320px"
          objectFit="cover"
          src={url}
          alt={name}
          borderRadius="var(--border-radius16)"
          data-testid="chat-image-preview"
          contentType={contentType}
        />
      </Button>
    </Box>
  );
};

export default ChatMessageImageAttachment;
